var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"mx-auto mb-4 mt-12",staticStyle:{"display":"block","width":"170px !important"},attrs:{"src":require("../../../assets/img/people_search.svg"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }